import { ApmBase } from '@elastic/apm-rum';

import { getLastClickedName } from './apmClickTracking';

/**
 * Initialize all APM filters for transaction naming
 */
export const initializeApmFilters = (apm: ApmBase) => {
  apm.addFilter((payload) => {
    try {
      if (payload.transactions) {
        payload.transactions.forEach((transaction: any) => {
          // Handle user-interaction transactions (clicks)
          if (transaction.type === 'user-interaction') {
            const clickName = getLastClickedName();
            if (clickName) {
              transaction.name = clickName;
            }
          }
        });
      }
    } catch (error) {
      console.error('[APM] Filter error:', error);
    }
    return payload;
  });
};
